import TransparentControlPanel from './TransparentControlPanel'
export {
  TransparentControlPanel
}



// WEBPACK FOOTER //
// ./src/app/components/common/controlPanel/index.js